import classNames from 'classnames';
import type { ReactElement, RefObject } from 'react';
import { useRef } from 'react';
import Image from '../../atoms/image/Image';
import type { ImageBlockProps } from './ImageBlock.data';
import styles from './ImageBlock.module.scss';
import { MediaLayout } from '../../utils/media-layout/MediaLayout';
import useThemeScrollBlock from '../../../hooks/useThemeScrollBlock';
import { cleanMediaQueries } from '../../../hooks/useDeviceStateTracker';

export default function ImageBlock({ className, blok, ref }: ImageBlockProps): ReactElement {
  const localRef = useRef(null);
  const elementRef = (ref || localRef) as RefObject<HTMLDivElement | null>;

  let imageSizes = `${cleanMediaQueries.MIN_768} 768px, ${cleanMediaQueries.MIN_1920} 1024px, 100vw`;
  let innerImageTransitionProps = {};
  if (blok.layout_size !== 'small') {
    imageSizes = '100vw';

    if (!blok.no_inner_parallax) {
      innerImageTransitionProps = {
        innerTransition: {
          type: 'scaleUp',
        },
      };
    }
  }

  useThemeScrollBlock(elementRef, blok.use_accent_color);

  return (
    <MediaLayout
      ref={elementRef}
      className={classNames(styles.imageBlock, className, {
        [styles.noMargins]: blok.no_margins,
      })}
      blok={blok}
    >
      <Image
        src={blok.image.filename}
        srcDesktop={blok.image.filename}
        className={classNames(styles.image)}
        {...innerImageTransitionProps}
        sizes={imageSizes}
        layout="responsive"
        objectFit="cover"
        alt={blok.image.alt}
      />
    </MediaLayout>
  );
}
